/* eslint-disable no-unused-vars */

export enum BenefitSettingsType {
  COMMUTER = 'commuter',
  MEDICAL = 'medical',
  LIFE_INSURANCE = 'life_insurance',
  RETIREMENT = 'retirement',
  ACCOUNT = 'account',
  GENERAL = 'general',
  ELECT_COVERAGE = 'elect_coverage',
}

export type ElectCoverageSettings = {
  amount: number;
  rate: number;
  EOI: boolean;
}[];

export type CommuterSettings = {
  employeeChoosesTheAmountToPay: 'YES' | 'NO';
  limitTheEmployeeCanPay?: number;
  minimumLimitTheEmployeeCanPay?: number;
  employeeChosenAmountToPay?: number;
  timeLimitThatEmployeePaymentApplies?: 'Annual' | 'Monthly' | 'Bi-Weekly' | 'Semi Monthly';
  employeeChoosesPayment?: 'Yes' | 'No' | undefined;
};

export type MedicalSpendingAccounts = {
  type: 'DCA' | 'HCA' | 'FSA';
  employeeChosenAmountToPay: number;
};

export type MedicalSettings = {
  level: 'LOW' | 'MID' | 'HIGH';
  spendingAccounts: Array<MedicalSpendingAccounts>;
};

export type LifeInsuranceSettings = {
  beneficiaries: {
    personId: string;
    percentToPay: number;
    name: string;
  }[];
};

export type DependentsSettings = {
  dependents: {
    personId: string;
    name: string;
  }[];
};

export interface BenefitSettings {
  type: BenefitSettingsType;
  rates?: ElectCoverageSettings;
  data: CommuterSettings | MedicalSettings | LifeInsuranceSettings | DependentsSettings | null;
}

export interface IBenefitType {
  blockerTypes: string[] | undefined;
  typeAlias: string;
  type: string;
  generalCategory: string;
  imgURL?: string;
  whenEmployeeCanEnroll?: string;
  mandatory?: string;
  spouseMaxAge?: number;
  spouseAge?: number;
}

export interface IEnrollmentEvent {
  id: string;
  name: string;
  eventStartDate: string;
  eventEndDate: string;
  planInitialPeriod: string;
  planEndPeriod: string;
  createdAt: string;
  status: string;
  message: string;
}

export interface IBeneficiary {
  beneficiaryName: string;
  beneficiaryRelationShip: string;
  beneficiaryType: string;
  beneficiaryPercentToPay: string;
}

export interface IBenefitListTable extends Omit<IBenefit, 'effective' | 'expiration'> {
  rates: {
    value: string;
    columns: string[];
    rows: string[][];
  };
  status: string;
  waitingSync: string;
}

export interface IBenefit {
  benefitName: string;
  benefitId: string;
  imgURL?: string;
  benefitPlanId: string;
  benefitOptionId: string;
  benefitEnrollmentStart: string;
  benefitEnrollmentEnd: string;
  benefitProvider: string;
  costCalculationMethod?: string;
  employeeName: string;
  employeeCost: number;
  employerName: string;
  employerCost: number;
  generalCategory: string;
  type: string;
  basis?: string;
  validFrom?: string;
  validTo?: string;
  expiration: string;
  percent: number;
  fixedAmount: number;
  price: number;
  planDescription: string;
  optionDescription: string;
  dependents: string;
  dependentsDescription?: string;
  typeAlias?: string;
  ignoreSmokerFilter?: boolean;
  enrollable?: boolean;
  necessaryToProvideBeneficiariesInformation?: boolean;
  employeeChoosesPayment: 'Yes' | 'No' | null;
  settings?: BenefitSettings;
  coverageAmount?: number;
  date?: string;
  coveredSpouse?:
    | [
        {
          id: string;
          name: string;
        },
      ]
    | [];
  coveredChildren?:
    | [
        {
          id: string;
          name: string;
        },
      ]
    | [];
  beneficiaries?: IBeneficiary[];
  mandatory?: boolean;
  versionId?: string;
  planDocument?: string;
  version?: string;
  hasPlanDocument?: Number | string | boolean;
  hasSmokerOption?: boolean | undefined;
  smoker?: boolean;
}

export type BenefitCartAction = 'ADD' | 'REMOVE' | 'DECLINED';
export interface ICartBenefit extends IBenefit {
  action: BenefitCartAction;
}

export interface IBenefitEnrollmentItem {
  benefitId: string;
  employeeChosenAmountToPay?: number;
  beneficiaryIds?: string[];
  spendingAccounts?: MedicalSettings['spendingAccounts'];
}

export interface IBenefitsReview {
  benefitId: string;
  plan: string;
  employeeId: string;
  employeeName: string;
  dependentIncluded: string;
  dependents: string;
  beneficiaries: string;
  type: string;
  status: 'Elected' | 'Waived' | 'Not Selected' | 'Removed';
  price: number;
  annualCost: number;
  coverageAmount: number;
  approvalStatus?: string;
  electedDate?: string;
  smoker?: string;
  beneficiaryInfo?: { personId: string; percentage: string }[];
  dependentsInfo?: { personId: string }[];
}
